import { Box } from '@mui/material'
import { SchedulerTabsProps } from './Scheduler.types'
import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerSynchronizedLinesTable } from './SchedulerSynchronizedLines.muiTable'
import { ManagedSourceBanner } from './ManagedSourceBanner'
import { SECTIONS } from './SchedulerInput.sections'

export const ScheduleSynchronizedLines = ({
  schedulerId,
  iteration,
  readOnly = false,
  onOpenRule,
}: SchedulerTabsProps & {
  readOnly?: boolean
  onOpenRule?: (tab: string) => void
}) => {
  const API = 'synchronized-lines'
  const { data: responseData = { data: [], predicate: undefined }, isLoading } =
    useScheduleProductionRequirements(schedulerId, API, iteration)
  const { data = [], predicate } = responseData

  const {
    updateTableData,
    uploadScheduleData,
    isSaving,
    isUploading,
    updateRowsStatus,
  } = useSchedulerTableHandlers(schedulerId, API, iteration)

  return (
    <Box sx={{ height: 'calc(100vh - 240px)', minHeight: 400 }}>
      {readOnly && onOpenRule && (
        <ManagedSourceBanner
          label="Crew & Sync"
          onOpen={() => onOpenRule(SECTIONS.RULES_CREW_SYNC)}
        />
      )}
      <SchedulerSynchronizedLinesTable
        data={data}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadScheduleData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        updateRowsStatus={updateRowsStatus}
        predicate={predicate}
        readOnly={readOnly}
      />
    </Box>
  )
}
